// Iter86b — Admin · Logistics Approval Queue.
//
// Lists requests with `status: pending` approval rows so an admin can
// drill in and approve/reject from the request detail page.
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { usePendingApprovals } from "../api/logistics";

export default function AdminLogisticsApprovalQueue() {
  const q = usePendingApprovals();
  const rows = q.data?.items || [];
  return (
    <div className="space-y-4" data-testid="admin-logistics-approval-queue">
      <header>
        <h1 style={{ fontFamily: "Syne, sans-serif", fontWeight: 800, fontSize: 22, color: "var(--text-primary)" }}>Approval Queue</h1>
        <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 10, color: "var(--text-dimmer)", letterSpacing: "1.5px", textTransform: "uppercase" }}>{rows.length} pending</div>
      </header>
      <div className="rounded-md overflow-hidden" style={card}>
        <div className="grid items-center px-3 py-2" style={{ gridTemplateColumns: "1.4fr 1fr 0.8fr 1.2fr 0.6fr", background: "var(--bg-elevated)", borderBottom: "1px solid var(--border-strong)" }}>
          {["Deal", "Customer", "Amount", "Triggers", ""].map((h) => (
            <div key={h} style={{ fontFamily: "'DM Mono', monospace", fontSize: 9, color: "var(--text-dimmer)", letterSpacing: "1.5px", textTransform: "uppercase" }}>{h}</div>
          ))}
        </div>
        {rows.map((r) => (
          <div key={r.id} className="grid items-center px-3 py-2" style={{ gridTemplateColumns: "1.4fr 1fr 0.8fr 1.2fr 0.6fr", borderBottom: "1px solid var(--border-soft)" }} data-testid={`admin-approval-row-${r.request_id}`}>
            <div>
              <div style={{ fontFamily: "Syne, sans-serif", fontWeight: 600, fontSize: 12, color: "var(--text-primary)" }}>{r.request?.deal_name || r.request_id}</div>
              <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 9, color: "var(--text-dimmer)" }}>{r.request_id}</div>
            </div>
            <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 10, color: "var(--text-dim)" }}>{r.request?.customer_name || "—"}</span>
            <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 10, color: "#22a35a", fontWeight: 700 }}>{r.request?.amount ? `${Number(r.request.amount).toLocaleString()} ${r.request?.currency || "EUR"}` : "—"}</span>
            <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 9, color: "var(--text-dim)" }}>{(r.triggers || []).join(", ") || "—"}</span>
            <Link to={`/logistics-requests/${r.request_id}`} className="inline-flex items-center gap-1 px-2 py-1 rounded" style={btnPrimary} data-testid={`admin-aq-open-${r.request_id}`}>
              OPEN <ArrowRight size={11} />
            </Link>
          </div>
        ))}
        {rows.length === 0 && <div className="px-3 py-6 text-center" style={{ fontFamily: "'DM Mono', monospace", fontSize: 11, color: "var(--text-dimmer)" }}>No pending approvals</div>}
      </div>
    </div>
  );
}

const card = { background: "var(--bg-surface)", border: "1px solid var(--border-strong)" };
const btnPrimary = { background: "#185FA5", border: "1px solid #0d3f78", color: "#ffffff", fontFamily: "'DM Mono', monospace", fontWeight: 700, fontSize: 10, letterSpacing: "0.4px", cursor: "pointer", textDecoration: "none" };
